// import config from '@/config'

import { routeHasExist, getRouteTitleHandled, getNextRoute, routeEqual } from '@/utils/util'
import { getTagNavListFromLocalstorage, setTagNavListInLocalstorage } from '@/utils/cache'
import router from '@/router'
import config from '@/config'
const { homeName } = config

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route)
  state.tagNavList = state.tagNavList.filter(item => {
    return !routeEqual(item, route)
  })
  router.push(nextRoute)
}

const app = {
  state: {
    tagNavList: getTagNavListFromLocalstorage(),
    columnFilters: {},
    errorList: [],
    currentMenu: '',
    accessToken: '',
    refreshToken: '',
    authorities: [],
    userInfo: {},
    accessResources: [],
    skin: ''
  },
  mutations: {
    setSkin(state, skin) {
      state.skin = skin
    },
    setColumnFilters(state, { tableName, columns }) {
      state.columnFilters[tableName] = columns
    },
    setCurrentMenu(state, route) {
      state.currentMenu = route.meta && route.meta.title ? route.meta.title : route.name
    },
    setToken(state, res) {
      state.accessToken = res.access_token
      state.refreshToken = res.refresh_token
    },
    removeToken(state) {
      state.accessToken = ''
      state.refreshToken = ''
    },
    setAuthorities(state, res) {
      state.authorities = res
    },
    setUserInfo(state, res) {
      state.userInfo = res
    },
    removeUserInfo(state) {
      state.userInfo = {}
    },
    removeAuthorities(state) {
      state.authorities = []
    },
    setAccessResources(state, res) {
      state.accessResources = res
    },
    removeAccessResources(state) {
      state.accessResources = []
    },
    removeTagNavList(state, list) {
      state.tagNavList = []
      setTagNavListInLocalstorage([])
    },
    setTagNavList(state, list) {
      let tagList = []
      tagList = list ? [...list] : (getTagNavListFromLocalstorage() || [])
      if (tagList[0] && tagList[0].name !== homeName) {
        tagList.shift()
      }
      const homeTagIndex = tagList.findIndex(item => item.name === homeName)
      if (homeTagIndex > 0) {
        const homeTag = tagList.splice(homeTagIndex, 1)[0]
        tagList.unshift(homeTag)
      }
      state.tagNavList = tagList
      setTagNavListInLocalstorage([...tagList])
    },
    closeTag(state, route) {
      const tag = state.tagNavList.filter(item => routeEqual(item, route))
      route = tag[0] ? tag[0] : null
      if (!route) return
      closePage(state, route)
    },
    addTag(state, { route, type = 'unshift' }) {
      const router = getRouteTitleHandled(route)
      if (!routeHasExist(state.tagNavList, router)) {
        if (type === 'push') {
          state.tagNavList.push(router)
        } else {
          // TODO
        }
        setTagNavListInLocalstorage([...state.tagNavList])
      }
    }
  },
  actions: {
    removeToken({ commit }) {
      commit('removeToken')
    }
  }
}
export default app
